import { Settings, ITimeZone } from './../../shared/models/settings.model';
import { Action } from '@ngrx/store';

export enum SettingsActionTypes {
    LOAD_SETTINGS = '[Settings] Load settings',
    LOAD_SETTINGS_SUCCESS = '[Settings] Load settings success',
    LOAD_SETTINGS_FAILURE = '[Settings] Load settings failure',
    LOAD_ZIPCODES = '[Settings] Load PMA zipcodes',
    LOAD_ZIPCODES_SUCCESS = '[Settings] Load PMA zipcodes success',
    LOAD_ZIPCODES_FAILURE = '[Settings] Load PMA zipcodes failure',
    UPDATE_SETTINGS = '[Settings] Update settings',
    UPDATE_SETTINGS_SUCCESS = '[Settings] Update settings success',
    UPDATE_SETTINGS_FAILURE = '[Settings] Update settings failure',
    LOAD_TIMEZONES = '[Settings] Load Timezones',
    LOAD_TIMEZONES_SUCCESS = '[Settings] Load Timezones success',
    LOAD_TIMEZONES_FAILURE = '[Settings] Load Timezones failure'
}


export class LoadSettings implements Action {
    readonly type: string = SettingsActionTypes.LOAD_SETTINGS;

    constructor(public payload: { department: string }) {
    }
}

export class LoadSettingsSuccess implements Action {
    readonly type = SettingsActionTypes.LOAD_SETTINGS_SUCCESS;

    constructor(public payload: { settings: Settings }) {
    }
}

export class LoadSettingsFailure implements Action {
    readonly type = SettingsActionTypes.LOAD_SETTINGS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadZipcodes implements Action {
    readonly type: string = SettingsActionTypes.LOAD_ZIPCODES

    constructor(public payload: { department: string }) {
    }
}

export class LoadZipcodesSuccess implements Action {
    readonly type = SettingsActionTypes.LOAD_ZIPCODES_SUCCESS;

    constructor(public payload: { zipcodes: string[] }) {
    }
}

export class LoadZipcodesFailure implements Action {
    readonly type = SettingsActionTypes.LOAD_ZIPCODES_FAILURE;

    constructor(public payload: { error: string }) {
    }
}


export class UpdateSettings implements Action {
    readonly type = SettingsActionTypes.UPDATE_SETTINGS;
    constructor(public payload: { department: string, settings: Settings }) {
    }
}

export class UpdateSettingsSuccess implements Action {
    readonly type = SettingsActionTypes.UPDATE_SETTINGS_SUCCESS;
    constructor(public payload: { settings: Settings }) {
    }
}

export class UpdateSettingsFailure implements Action {
    readonly type = SettingsActionTypes.UPDATE_SETTINGS_FAILURE;
    constructor(public payload: { error: string }) {
    }
}

export class LoadTimezones implements Action {
    readonly type: string = SettingsActionTypes.LOAD_TIMEZONES

    constructor() {
    }
}

export class LoadTimezonesSuccess implements Action {
    readonly type: string = SettingsActionTypes.LOAD_TIMEZONES_SUCCESS

    constructor(public payload: { timezones: ITimeZone[] }) {
    }
}

export class LoadTimezonesFailure implements Action {
    readonly type: string = SettingsActionTypes.LOAD_TIMEZONES_FAILURE

    constructor(public payload: { error: any }) {
    }
}

export type SettingsActions =
    LoadSettings
    | LoadSettingsSuccess
    | LoadSettingsFailure
    | UpdateSettings
    | UpdateSettingsSuccess
    | UpdateSettingsFailure
    | LoadTimezones
    | LoadTimezonesSuccess
    | LoadTimezonesFailure
    | LoadZipcodes
    | LoadZipcodesSuccess;
